import api from './api';

const roomService = {
  // Get all rooms
  getAllRooms: (params = {}) => {
    return api.get('/api/rooms', { params });
  },

  // Get vacant rooms
  getVacantRooms: () => {
    return api.get('/api/rooms/vacant');
  },

  // Get single room
  getRoom: (id) => {
    return api.get(`/api/rooms/${id}`);
  },

  // Create new room
  createRoom: (data) => {
    return api.post('/api/rooms', data);
  },

  // Update room
  updateRoom: (id, data) => {
    return api.put(`/api/rooms/${id}`, data);
  },

  // Delete room
  deleteRoom: (id) => {
    return api.delete(`/api/rooms/${id}`);
  },

  // Assign tenant to room
  assignRoom: (roomId, data) => {
    return api.post(`/api/rooms/${roomId}/assign`, data);
  },

  // Vacate room
  vacateRoom: (roomId) => {
    return api.post(`/api/rooms/${roomId}/vacate`);
  },
};

export default roomService;
